// Foresight checklist work view (/ennakointi, #630): step 3, scenarios.v2 — the tulevaisuuskuvat.
// Split from foresightStrings.js (#1199). Merged into the `foresight` namespace next to it.

export const foresightScenarioFi = {
  scenarios: {
    title: 'Tulevaisuuskuvat',
    lead: 'Tekoäly muodostaa skenaarion muutosvoimista kolme tulevaisuuskuvaa: jatkuvuuden, myönteisen ja kielteisen. Ne eivät ole ennusteita vaan ajattelun välineitä. Muokkaa, muodosta uudelleen tai hylkää, ja hyväksy lopuksi. Tulevaisuuskuvien muodostus ja arviointi voi kestää noin minuutin.',
    generate: 'Muodosta tulevaisuuskuvat',
    regenerateAll: 'Muodosta koko joukko uudelleen',
    confirmRegenerateAll: 'Koko joukon muodostaminen uudelleen korvaa nykyiset tulevaisuuskuvat ja niihin tehdyt muokkaukset. Jatketaanko?',
    archetypes: { bau: 'Jatkuvuus', positive: 'Myönteinen', negative: 'Kielteinen' },
    summary: 'Tiivistelmä',
    narrative: 'Kuvaus',
    subjectView: 'Miltä tarkasteltava asia näyttää tässä tulevaisuudessa',
    driverOutcomes: 'Muutosvoimat tässä tulevaisuuskuvassa',
    opportunities: 'Mahdollisuudet',
    risks: 'Riskit',
    assumptions: 'Oletukset',
    listHint: 'Yksi per rivi',
    regenerate: 'Muodosta uudelleen',
    regenerateReason: 'Mitä uudessa versiossa pitäisi muuttaa? (vapaaehtoinen, tekoäly ottaa sen huomioon)',
    regenerateSave: 'Muodosta uudelleen tällä ohjeella',
    addAlternative: 'Pyydä uusi vaihtoehto',
    draft: 'Luonnos',
    approvedBadge: 'Hyväksytty',
    assess: 'Arvioi erilaisuus',
    assessmentTitle: 'Ovatko tulevaisuuskuvat riittävän erilaisia?',
    stale: 'Tulevaisuuskuvia on muutettu arvion jälkeen.',
    verdicts: {
      green: 'Riittävän erilaiset', yellow: 'Osin samankaltaiset', red: 'Liian samankaltaiset',
    },
    mirror: 'Myönteinen ja kielteinen ovat toistensa peilikuvia',
    criteria: {
      relevance: 'Relevanssi', distinctness: 'Erilaisuus', consistency: 'Johdonmukaisuus',
      concreteness: 'Konkreettisuus', transparency: 'Läpinäkyvyys',
    },
    pairs: 'Parittain',
    approve: 'Hyväksy tulevaisuuskuvat',
    approvedNote: 'Skenaario tulevaisuuskuvineen on nyt Kuution skenaario; muutokset tallentuvat suoraan.',
    hasContent: 'Vaikutuskartalla on jo sisältöä tämän tulevaisuuskuvan pohjalta, joten sitä ei voi poistaa eikä nimetä uudelleen.',
    mapContentLock: 'Vaikutuskartta on jo rakennettu tämän skenaarion pohjalta, joten sen tulevaisuuskuvia ei voi luoda uudelleen. Vaihtoehdon voi yhä pyytää.',
  },
};

export const foresightScenarioEn = {
  scenarios: {
    title: 'Future images',
    lead: "The AI builds three future images from the scenario's change drivers: business as usual, positive and negative. They are thinking tools, not forecasts. Edit, rebuild or reject them, then approve. Building and assessing the future images can take about a minute.",
    generate: 'Build future images',
    regenerateAll: 'Rebuild the whole set',
    confirmRegenerateAll: 'Rebuilding the whole set replaces the current future images and the edits made to them. Continue?',
    archetypes: { bau: 'Business as usual', positive: 'Positive', negative: 'Negative' },
    summary: 'Summary',
    narrative: 'Description',
    subjectView: 'What the subject looks like in this future',
    driverOutcomes: 'The drivers in this future image',
    opportunities: 'Opportunities',
    risks: 'Risks',
    assumptions: 'Assumptions',
    listHint: 'One per line',
    regenerate: 'Rebuild',
    regenerateReason: 'What should change in the new version? (optional, the AI takes it into account)',
    regenerateSave: 'Rebuild with this guidance',
    addAlternative: 'Ask for a new alternative',
    draft: 'Draft',
    approvedBadge: 'Approved',
    assess: 'Assess difference',
    assessmentTitle: 'Are the future images different enough?',
    stale: 'The future images have changed since this assessment.',
    verdicts: {
      green: 'Different enough', yellow: 'Partly similar', red: 'Too similar',
    },
    mirror: 'Positive and negative are mirror images of each other',
    criteria: {
      relevance: 'Relevance', distinctness: 'Distinctness', consistency: 'Consistency',
      concreteness: 'Concreteness', transparency: 'Transparency',
    },
    pairs: 'Pairwise',
    approve: 'Approve the future images',
    approvedNote: 'The scenario and its future images are now one of this Kuutio\'s scenarios; changes are saved directly.',
    hasContent: 'The impact map already has content built on this future image, so it cannot be removed or renamed.',
    mapContentLock: 'The impact map is already built on this scenario, so its future images can no longer be regenerated. You can still ask for an alternative.',
  },
};

export const foresightScenarioSv = {
  scenarios: {
    title: 'Framtidsbilder',
    lead: 'AI:n bygger tre framtidsbilder av scenariots förändringskrafter: fortsatt utveckling, positivt och negativt. De är tankeverktyg, inte prognoser. Redigera, bygg om eller avvisa, och godkänn till sist. Att bygga och bedöma framtidsbilderna kan ta ungefär en minut.',
    generate: 'Bygg framtidsbilder',
    regenerateAll: 'Bygg om hela uppsättningen',
    confirmRegenerateAll: 'Att bygga om hela uppsättningen ersätter nuvarande framtidsbilder och ändringarna i dem. Fortsätta?',
    archetypes: { bau: 'Fortsatt utveckling', positive: 'Positivt', negative: 'Negativt' },
    summary: 'Sammanfattning',
    narrative: 'Beskrivning',
    subjectView: 'Hur det granskade ser ut i den här framtiden',
    driverOutcomes: 'Förändringskrafterna i den här framtidsbilden',
    opportunities: 'Möjligheter',
    risks: 'Risker',
    assumptions: 'Antaganden',
    listHint: 'En per rad',
    regenerate: 'Bygg om',
    regenerateReason: 'Vad borde ändras i den nya versionen? (frivilligt, AI:n beaktar det)',
    regenerateSave: 'Bygg om med den här anvisningen',
    addAlternative: 'Be om ett nytt alternativ',
    draft: 'Utkast',
    approvedBadge: 'Godkänt',
    assess: 'Bedöm skillnaderna',
    assessmentTitle: 'Skiljer sig framtidsbilderna tillräckligt?',
    stale: 'Framtidsbilderna har ändrats efter bedömningen.',
    verdicts: {
      green: 'Tillräckligt olika', yellow: 'Delvis lika', red: 'För lika',
    },
    mirror: 'Det positiva och det negativa är spegelbilder av varandra',
    criteria: {
      relevance: 'Relevans', distinctness: 'Särart', consistency: 'Konsekvens',
      concreteness: 'Konkretion', transparency: 'Transparens',
    },
    pairs: 'Parvis',
    approve: 'Godkänn framtidsbilderna',
    approvedNote: 'Scenariot med sina framtidsbilder är nu ett av Kuutions scenarier; ändringar sparas direkt.',
    hasContent: 'Effektkartan har redan innehåll byggt på den här framtidsbilden, så den kan inte tas bort eller byta namn.',
    mapContentLock: 'Effektkartan har redan byggts på det här scenariot, så dess framtidsbilder kan inte längre skapas på nytt. Du kan fortfarande be om ett alternativ.',
  },
};
